import Generic from './Generic.jsx';
import './Generic.css';

export default Generic;
